import { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface AddGuestButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  children: ReactNode;
}

export const AddGuestButton: FC<AddGuestButtonProps> = ({ icon, children, type = 'button', ...props }) => (
  <button type={type} {...stylex.props(styles.button)} {...props}>
    {icon}
    <span {...stylex.props(styles.text)}>{children}</span>
  </button>
);
